import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CreateVoucherApi } from "../../Utils/Api/CreateVoucherApi";
import Loader from "../Loader/Loader";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";

const Modals = ({ saveButtonfuc, Apidata, ...props }) => {
  const [loading, setLoading] = useState(false);

  const dataApi = props.saveButton;
  const navigate = useNavigate();



  // const voucherCreater = async () => {
  //   setLoading(true);
  //   const res = await CreateVoucherApi(dataApi);
  //   if (res === false) {
  //     toast.error(ServerError, {
  //       position: "top-center",
  //       autoClose: 1000,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "dark",
  //     });
  //     setLoading(false);
  //   } else {
  //     if (res.success === true) {
  //       toast.success("Voucher successfully created", {
  //         position: "top-center",
  //         width: "500px",
  //         autoClose: 1000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "dark",
  //       });
  //       // setErrorLabelapi("Voucher successfully created");
  //       props.onHide();
  //       navigate("/my-account/manage-vouchers");
  //       setLoading(false);
  //     } else {
  //       toast.error(res.message, {
  //         position: "top-center",
  //         autoClose: 1000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "dark",
  //       });
  //       props.onHide();
  //       setLoading(false);
  //     }
  //   }
  // };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="Modal">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modalMain create-vou-modal"
        >
          <Modal.Header closeButton></Modal.Header>

          <Modal.Body>
            <div className={props.className}>
              <img loading="lazy" src={props.images} />
              <p style={{paddingTop: "20px"}}>{props.description}</p>
              <div className="modal-buttons">
                <button onClick={props.onHide}>{props.firstbutton}</button>
                <button
                  onClick={() => {
                    saveButtonfuc(Apidata)
                  }}
                >
                  {props.secondbutton}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Modals;
